import { Injectable } from '@angular/core';
import { AuthStorage, TixAuthService } from '@tix/auth/services';
import { TixGrantAccessToCompanyGQL } from '@tix/data-access';

@Injectable()
export class CompanyAccessService {
  constructor(
    private authService: TixAuthService,
    private grantAccessToCompanyMutation: TixGrantAccessToCompanyGQL
  ) {}

  async switchToCompany(companyId: string): Promise<string> {
    const currentToken = await this.authService.getToken().toPromise();
    if (!currentToken) {
      throw new Error('Not authenticated');
    }

    const hasuraClaims = await this.authService.getHasuraClaims();

    if (hasuraClaims && hasuraClaims['x-hasura-company-id'] === companyId) {
      const defaultRole = hasuraClaims['x-hasura-default-role'];
      AuthStorage.setItem('role', defaultRole);
      AuthStorage.setItem('selectedCompanyId', companyId);
      return currentToken;
    }

    await this.grantAccessToCompanyMutation
      .mutate({
        currentToken,
        companyId
      })
      .toPromise();

    const newToken = await this.authService.refreshToken();

    const newClaims = await this.authService.getHasuraClaims();
    console.debug(newClaims);

    const defaultRole = newClaims!['x-hasura-default-role'];

    AuthStorage.setItem('role', defaultRole);
    AuthStorage.setItem('selectedCompanyId', companyId);
    AuthStorage.setItem('token', newToken!);

    return newToken!;
  }
}
